import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../services/auth.service';

const TenantRoute: React.FC = () => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/signin" replace />;
  }
  if (!authService.isTenant()) {
    const role = authService.getUserRole();
    if (role === 'OWNER' || role === 'ADMIN') {
      return <Navigate to="/dashboard" replace />;
    }
    // No role in storage (legacy session) → force re-login
    authService.logout();
    return <Navigate to="/signin" replace />;
  }
  return <Outlet />;
};

export default TenantRoute;
